import { render, staticRenderFns } from "./SidebarStyle.vue?vue&type=template&id=238f6c58"
import script from "./SidebarStyle.vue?vue&type=script&lang=js"
export * from "./SidebarStyle.vue?vue&type=script&lang=js"
import style0 from "./SidebarStyle.vue?vue&type=style&index=0&id=238f6c58&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports